module.exports = __webpack_public_path__ + "static/media/smartmockups_k0p13jc6.4ea619d9.png";